<p>シートマップ</p>
<button id="ssn-test-seatmap1" class="testButton" (click)="goToSeatmapPage()">シートマップへ</button>
<button id="ssn-test-seatmap2" class="testButton" (click)="openChildSeatNotSelectableConfirmationModal()">
  選択不可確認モーダル
</button>
<button id="ssn-test-seatmap3" class="testButton" (click)="setSeatmapStore()">仮ストア情報設定</button>
